import React, { useEffect, useState } from 'react'
import { Vertical, NothingMessage } from '@gravitate-js/excalibrr'
import { DirectiveMetrics } from './DirectiveMetrics'
import { PriceMetrics } from './PriceMetrics'
import { useDirectiveContext } from '../../DirectiveContext'
import api from '@utils/api'
import moment from 'moment'

export const IntramonthDirectiveStatus = () => {
  const { selectedDirective, selectedPrice, selectedDate } = useDirectiveContext()
  const [directiveMetrics, setDirectiveMetrics] = useState()
  const [metricsLoading, setMetricsLoading] = useState(true)
  const showNothing = !selectedDirective && !selectedPrice
  const showDirective = !selectedPrice && !!selectedDirective

  const grabDate = () => {
    const isCurrentMonth = moment(selectedDate)?.isSame(new Date(), 'month')
    if (isCurrentMonth) {
      return moment().startOf('day').add(10, 'minutes').toISOString()
    }
    return moment(selectedDate)?.endOf('month').startOf('day').toISOString()
  }
  useEffect(() => {
    if (!selectedDirective) {
      return
    }
    setMetricsLoading(true)
    api
      .getMonthlyAnalytics(selectedDirective.curve_group_id, grabDate(), selectedDirective.monthly_allocation || 20000)
      .then((resp) => {
        setMetricsLoading(false)
        setDirectiveMetrics(resp.data)
      })
  }, [selectedDirective])
  return (
    <Vertical verticalCenter className='pl-4' flex={1}>
      {selectedPrice && (
        <PriceMetrics
          metricsLoading={metricsLoading}
          selectedPrice={selectedPrice}
          directiveMetrics={directiveMetrics}
        />
      )}
      {showDirective && (
        <DirectiveMetrics
          metricsLoading={metricsLoading}
          selectedDirective={selectedDirective}
          directiveMetrics={directiveMetrics}
        />
      )}
      {showNothing && (
        <Vertical background='bg-2' border='all' borderRadius={3} flex={1}>
          <NothingMessage
            title='No Directive Selected'
            message='Select a directive to view its status for the month.'
          />
        </Vertical>
      )}
    </Vertical>
  )
}
